module.exports = __webpack_public_path__ + "img/dailyReport.3dc5f0a2.png";